import { HTTP } from '@/shared/http';

export default {
    state: {
        designs: [],
        stateSelectedTemplate: null
    },
    mutations: {
        setBrandingDesign(state, designs) {
            state.designs = designs;
        },
        setSelectedTemplate(state, template) {
            state.stateSelectedTemplate = template;
        }
    },
    getters: {
        designs(state) {
            return state.designs;
        },
        getSelectedTemplate(state) {
            return state.stateSelectedTemplate;
        }
    },
    actions: {
        loadDesign({ commit }) {
            const apiUrl = process.env.VUE_APP_API_URI_SEGMENT + '/designs';
            return HTTP.get(apiUrl)
            .then((response) => {
                commit("setBrandingDesign", response.data);
            })
            .catch((err) => {
                alert(this.$t(err.response.data.error));
            });
        },
        storeBrandingDesign({ commit }, branding) {
            commit('setBrandingDesign', branding);
        },
        updateSelectedTemplate({ commit }, template) {
            commit('setSelectedTemplate', template);
        }
    }
}